import cloneDeep from 'lodash/cloneDeep';

// Drill-down cursors must carry the window the dashboard actually rendered:
// a saved filter's relative preset ("last 30 days") is recomputed at query
// time, so replies to posts from the window's first days silently fall out
// of the drill-down. Materializing the executed window as a custom range
// pins the drill-down to the widget's own snapshot.
// Number() coerces null, '' and booleans to finite numbers, so bounds must be
// validated raw: a malformed window has to no-op, not pin the range to 1970.
const isValidBound = bound =>
    (typeof bound === 'number' || (typeof bound === 'string' && bound.trim() !== '')) &&
    Number.isFinite(Number(bound));

export default function pinRangeToExecutedWindow(properties, executedWindow) {
    if (
        !Array.isArray(properties) ||
        !Array.isArray(executedWindow) ||
        executedWindow.length !== 2 ||
        !executedWindow.every(isValidBound)
    ) {
        return properties;
    }

    const [from, to] = executedWindow.map(Number);

    if (from > to) {
        return properties;
    }

    return cloneDeep(properties).map(property => ({
        ...property,
        filters: {
            ...property.filters,
            range: { value: 'custom', range: [from, to] }
        }
    }));
}
